import { API_URL } from '../../environment';
import { ducksActionCreator } from '../ducksHelpers';

export const payoutPreferenceSettings = {
  stateName: 'payoutPreference',
  dataType: 'object',
  actions: {
    fetch: 'ducks/payouts/FETCH_PAYOUT_PREFERENCE',
  },
};

// Action Creators
export function fetchPayoutPreference(
  callback = () => {},
  errorCallback = () => {},
) {
  return ducksActionCreator(
    payoutPreferenceSettings.actions.fetch,
    'get',
    `${API_URL}/practice/provider_payout_preferences/me`,
    {},
    true,
    callback,
    errorCallback,
  );
}
